import { ConvertStringToHtmlId } from "../../../../../libs/ts/ConvertStringToHtmlId";
import { useFeedbackColour } from "../hooks/useFeedbackColour";

export enum feedbackColour {
    blue = "Blue",
    green = "Green",
    yellow = "Yellow",
    orange = "Orange",
    red = "Red",
    redText = "RedText"
}

export interface props {
    title: string,
    subTitle?: string,
    cells: string[],
    tagText?: string,
    feedbackColour: feedbackColour
    onClick?: () => void
    className?: string
}

export const ListItem = (props: props) => {
    const cellElements = props.cells?.map((cellOption, index: number) => {
        const classIdentifiers = `jbp-list-item-cell-${index}
            jbp-list-item-cell-${index}-with-title-${ConvertStringToHtmlId(props.title)}
            jbp-list-item-cell-${index}-with-subtitle-${props.subTitle == undefined ? "" : ConvertStringToHtmlId(props.subTitle)}`
        return (
            <div key={index} className={index > 0 ? 'text-soft-elevation-0' : ''}>
                <span className={classIdentifiers}>{cellOption}</span>
            </div>
        )
    })

    const [indicatorBorder, tagBackground] = useFeedbackColour(props.feedbackColour);

    const cursorJbp = props.onClick != undefined ? "cursor-pointer" : "";

    return (
        <div className={`
                jbp-list-item-with-title-${ConvertStringToHtmlId(props.title)}
                jbp-list-item-with-subtitle-${props.subTitle == undefined ? "" : ConvertStringToHtmlId(props.subTitle)}
                hover:bg-elevation-2 mb-2 rounded-sm bg-elevation-1 h-16 border-solid border-l-[5px] flex flex-row items-start ${indicatorBorder} ${cursorJbp} ${props.className}`} onClick={props.onClick}>
            <div className="w-1/5 pl-4 mt-2 text-nowrap">
                <p className="font-bold jbp-list-item-title">{props.title}</p>
                <p className="text-sm text-soft-elevation-0 jbp-list-item-subtitle">{props.subTitle == undefined ? "" : props.subTitle}</p>
            </div>
            <div className={`w-3/5 flex flex-col justify-center items-center h-full`}>
                {cellElements}
            </div>
            <div className="w-1/5 align-top mt-6">
                <div className={`
                        jbp-list-item-tag-with-title-${ConvertStringToHtmlId(props.title)}
                        jbp-list-item-tag-with-subtitle-${props.subTitle == undefined ? "" : ConvertStringToHtmlId(props.subTitle)}
                        rounded-3xl ${tagBackground} bg-feedback-blue text-center w-28 text-solid-deep-blue font-bold text-sm float-right mr-4`}>
                    {props.tagText}
                </div>
            </div>
        </div>
    )
}
